module.exports = {"id":"200332","name":"Tomáš Koubek","rating":"76","photo":"./data/images/photos/4/200332.png","club":{"name":"Stade Rennais","logo":"./data/images/clubs/StadeRennais.png"},"positions":["G"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/TomasKoubek0.json
// module id = 4176
// module chunks = 0